/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExchangeProgramPartnerSchoolOption
 */
export interface ExchangeProgramPartnerSchoolOption {
    /**
     * 
     * @type {number}
     * @memberof ExchangeProgramPartnerSchoolOption
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchoolOption
     */
    regionName: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchoolOption
     */
    countryName: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchoolOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchoolOption
     */
    nameJa: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchoolOption
     */
    partnerType: ExchangeProgramPartnerSchoolOptionPartnerTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ExchangeProgramPartnerSchoolOptionPartnerTypeEnum {
    Undergraduate = 'Undergraduate',
    Academic = 'Academic'
}

export function ExchangeProgramPartnerSchoolOptionFromJSON(json: any): ExchangeProgramPartnerSchoolOption {
    return ExchangeProgramPartnerSchoolOptionFromJSONTyped(json, false);
}

export function ExchangeProgramPartnerSchoolOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeProgramPartnerSchoolOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'regionName': json['regionName'],
        'countryName': json['countryName'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'partnerType': json['partnerType'],
    };
}

export function ExchangeProgramPartnerSchoolOptionToJSON(value?: ExchangeProgramPartnerSchoolOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'regionName': value.regionName,
        'countryName': value.countryName,
        'name': value.name,
        'nameJa': value.nameJa,
        'partnerType': value.partnerType,
    };
}


